
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHomePage = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHomePage
          ? 'bg-black/95 backdrop-blur-sm shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="px-8 lg:px-16">
        <div className="flex items-center justify-between h-20">
          {/* Brand Name */}
          <Link to="/" className="flex items-center">
            <h1 className="text-2xl lg:text-3xl font-black text-white tracking-wider">
              LOAD<span className="text-[#14B8A6]">&</span>SMOKE
            </h1>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className="text-white/90 hover:text-white text-sm uppercase tracking-widest transition-colors whitespace-nowrap"
            >
              Home
            </Link>
            <Link
              to="/blueprint-performance"
              className="text-white/90 hover:text-[#14B8A6] text-sm uppercase tracking-widest transition-colors whitespace-nowrap"
            >
              Blueprint Performance
            </Link>
            <Link
              to="/meat-mechanic"
              className="text-white/90 hover:text-[#06B6D4] text-sm uppercase tracking-widest transition-colors whitespace-nowrap"
            >
              Meat Mechanic
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white w-10 h-10 flex items-center justify-center"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <i className="ri-close-line text-2xl"></i>
            ) : (
              <i className="ri-menu-line text-2xl"></i>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/98 backdrop-blur-sm border-t border-white/10">
          <div className="px-8 py-6 space-y-4">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-white/90 hover:text-white text-sm uppercase tracking-widest transition-colors"
            >
              Home
            </Link>
            <Link
              to="/blueprint-performance"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-white/90 hover:text-[#14B8A6] text-sm uppercase tracking-widest transition-colors"
            >
              Blueprint Performance
            </Link>
            <Link
              to="/meat-mechanic"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-white/90 hover:text-[#06B6D4] text-sm uppercase tracking-widest transition-colors"
            >
              Meat Mechanic
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
